<template>
  <b-overlay :show="isLoadingFiles">
    <b-tabs pills card fill>
      <b-tab :title="$t('file_content.bruto')" lazy>
        <b-button size="sm" variant="outline-secondary" class="copy-btn" @click="copyToClipboard(normal)">
          <b-icon icon="clipboard" /> {{ $t('file_content.copiar') }}
        </b-button>
        <div class="bruto">{{ normal }}</div>
      </b-tab>
      <b-tab :title="$t('file_content.formatado')" lazy>
        <b-button size="sm" variant="outline-secondary" class="copy-btn" @click="copyToClipboard(parsedText)">
          <b-icon icon="clipboard" /> {{ $t('file_content.copiar') }}
        </b-button>
        <pre>{{ parsed }}</pre>
      </b-tab>
    </b-tabs>
  </b-overlay>
</template>

<script>
import FileRepository from "@/repositories/monitorExams/FileRepository";

export default {
  name: "FilesContent",
  props: {
    file: {
      type: Object
    }
  },
  data() {
    return {
      isLoadingFiles: false,
      normal: null,
      parsed: null
    }
  },
  computed: {
    parsedText() {
      if (this.parsed === null) return ''
      if (typeof this.parsed === 'string') return this.parsed
      return JSON.stringify(this.parsed, null, 2)
    }
  },
  methods: {
    convertFile(fileContent) {
      try {
        if (fileContent.charAt(0) === '<') {
          return this.formatXml(fileContent)
        } else {
          return JSON.parse(fileContent)
        }
      } catch (e) {
        return fileContent
      }
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text || '').then(() => {
        this.$bvToast.toast(this.$t('file_content.copiado_sucesso'), {
          title: this.$t('file_content.copiar'),
          variant: 'success',
          autoHideDelay: 2000,
          noCloseButton: true
        })
      })
    },
    formatXml(xml) {
      var reg = /(>)\s*(<)(\/*)/g; // updated Mar 30, 2015
      var wsexp = / *(.*) +\n/g;
      var contexp = /(<.+>)(.+\n)/g;
      xml = xml.replace(reg, '$1\n$2$3').replace(wsexp, '$1\n').replace(contexp, '$1\n$2');
      var pad = 0;
      var formatted = '';
      var lines = xml.split('\n');
      var indent = 0;
      var lastType = 'other';
      // 4 types of tags - single, closing, opening, other (text, doctype, comment) - 4*4 = 16 transitions
      var transitions = {
        'single->single': 0,
        'single->closing': -1,
        'single->opening': 0,
        'single->other': 0,
        'closing->single': 0,
        'closing->closing': -1,
        'closing->opening': 0,
        'closing->other': 0,
        'opening->single': 1,
        'opening->closing': 0,
        'opening->opening': 1,
        'opening->other': 1,
        'other->single': 0,
        'other->closing': -1,
        'other->opening': 0,
        'other->other': 0
      };

      for (var i = 0; i < lines.length; i++) {
        var ln = lines[i];

        // Luca Viggiani 2017-07-03: handle optional <?xml ... ?> declaration
        if (ln.match(/\s*<\?xml/)) {
          formatted += ln + "\n";
          continue;
        }
        // ---

        var single = Boolean(ln.match(/<.+\/>/)); // is this line a single tag? ex. <br />
        var closing = Boolean(ln.match(/<\/.+>/)); // is this a closing tag? ex. </a>
        var opening = Boolean(ln.match(/<[^!].*>/)); // is this even a tag (that's not <!something>)
        var type = single ? 'single' : closing ? 'closing' : opening ? 'opening' : 'other';
        var fromTo = lastType + '->' + type;
        lastType = type;
        var padding = '';

        indent += transitions[fromTo];
        for (var j = 0; j < indent; j++) {
          padding += '\t';
        }
        if (fromTo == 'opening->closing')
          formatted = formatted.substr(0, formatted.length - 1) + ln + '\n'; // substr removes line break (\n) from prev loop
        else
          formatted += padding + ln + '\n';
      }

      return formatted;
    },
  },
  async mounted() {
    if (!this.normal) {

      this.isLoadingFiles = true
      this.normal = ''

      await FileRepository.getContentOfFile({fileUrl: this.file.url})
          .then(responseFile => {
            this.normal = responseFile.data.content
            this.parsed = this.convertFile(this.normal)
          }).catch(e => {
            this.normal = e.response.data.message
            this.parsed = e.response.data.message
          })

      this.isLoadingFiles = false
    }
  }
}
</script>

<style lang="scss" scoped>
.copy-btn {
  position: absolute;
  top: 80px;
  right: 20px;
  z-index: 10;
}

/deep/ .tab-pane.active {
  width: 100%;
  height: 50vh;
  overflow: hidden;

  pre, .bruto {
    position: absolute;
    top: 90px;
    bottom: 0;
    left: 0;
    right: 0;
  }
}
</style>